
import * as Yup from 'yup';

export const elementosDeProteccionValidation = (elementosDeProteccionSeleccionados) => (
  Yup.object().shape({
    idElementoDeProteccion: Yup.number().required("Campo Obligatorio").nullable().test({
      name: "sinElementosRepetidos",
      message: "El elemento ya está asociado a este puesto.",
      test: function (value) {
        if (!(elementosDeProteccionSeleccionados.some((e) => e.idElementoDeProteccion === value))) {
          return true;
        }
        return false;
      },
    })
  })
);

export const medidasPreventivasValidation = (medidasPreventivasSeleccionadas) => (
  Yup.object().shape({
    idMedidaPreventiva: Yup.number().required("Campo Obligatorio").nullable().test({
      name: "sinMedidasRepetidas",
      message: "La medida ya está asociada a este puesto.",
      test: function (value) {
        if (!(medidasPreventivasSeleccionadas.some((e) => e.idMedidaPreventiva === value))) {
          return true;
        }
        return false;
      },
    })
  })
);

export const puestosAsociadosValidation = (puestosAsociadosASustancias) => Yup.object().shape({
  sustancia: Yup.string().nullable().required("Campo Obligatorio").test({
    name: "puestoYaAsociadoASustancias",
    message: "La combinación de sustancia y puesto ya existe en la grilla.",
    test: function (value) {
      if (!puestosAsociadosASustancias.some((e, index) => {
        return e?.puesto.toString() === this.parent.puesto && e?.sustancia.toString() === value && index !== this.parent?.index
      }
      )) {
        return true;
      }
      return false;
    }
  }),
  puesto: Yup.string().required("El puesto es obligatorio").nullable().test({
    name: "puestoYaAsociadoASustancias",
    message: "La combinación de sustancia y puesto ya existe en la grilla.",
    test: function (value) {
      if (!puestosAsociadosASustancias.some((e, index) => {
        return e?.puesto.toString() === value && e?.sustancia.toString() === this.parent.sustancia && index !== this.parent?.index
      }
      )) {
        return true;
      }
      return false;
    }
  }),
  nombrePuesto: Yup.string().required("El puesto es obligatorio"),
  descripcionActividades: Yup.string().required(
    "Descripción de actividades es obligatoria"
  ).max(200, "Máximo 200 caracteres"),
  descripcionEstudios: Yup.string().required(
    "Descripción de estudios es obligatoria"
  ).max(200, "Máximo 200 caracteres"),

});